<template>
    <l-marker :lat-lng="getCoordinates(item)" @click="openModal">
        <l-icon
            :icon-url="marker"
            :icon-size="iconSize"
            :icon-anchor="[15.375, 37.5]"
            ><img :src="marker" class="marker-icon"
        /></l-icon>
    </l-marker>
</template>
<script>
import { latLng } from "leaflet";
import { LIcon, LMarker } from "vue2-leaflet";

export default {
    name: "PointMarkerComponent",
    components: {
        LMarker,
        LIcon,
    },
    props: {
        item: {
            default: () => {},
        },
        iconSize: {
            default: () => [30.75, 37.5],
        },
        mapRef: {
            default: null,
        },
    },

    computed: {
        marker() {
            if (this.item.event_or_works_class === "_danger") {
                return "/svg/map/markers/conditions/hac-danger.svg";
            } else {
                return "/svg/map/markers/conditions/hac-warning.svg";
            }
        },
    },

    methods: {
        getCoordinates(item) {
            return latLng(item.geometry.coordinates);
        },
        openModal() {
            this.$parent.$parent.$parent.$refs.map.mapObject.setView(
                this.item.geometry.coordinates,
                12
            );

            this.$store.commit("setData", {
                name: "selectedCondition",
                data: this.item,
            });
        },
    },
};
</script>
